import { render, staticRenderFns } from "./ModelPlayer.vue?vue&type=template&id=775f03fc&scoped=true"
import script from "./ModelPlayer.vue?vue&type=script&lang=js"
export * from "./ModelPlayer.vue?vue&type=script&lang=js"
import style0 from "./ModelPlayer.vue?vue&type=style&index=0&id=775f03fc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "775f03fc",
  null
  
)

export default component.exports